import { IonCol } from '@ionic/react';
import { useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import ActionIconButton from '@components/buttons/ActionIconButton';
import DateInput from '@components/fields/DateInput';
import Select from '@components/fields/Select';
import styles from '@components/forms/AdminJourneyFilters.module.css';
import { TimePeriodEnum } from '@typing/Enums';

type PartialFormData = {
  endDate?: string | null;
  startDate?: string | null;
  timePeriod?: TimePeriodEnum | null;
};

type Props = {
  form: UseFormReturn<PartialFormData, any>;
};

const TimePeriodField = ({ form }: Props) => {
  const intl = useIntl();

  const timePeriod = form.watch('timePeriod');

  const timePeriodOptions = useMemo(() => {
    const options = [
      TimePeriodEnum.SEVEN_DAYS,
      TimePeriodEnum.THIRTY_DAYS,
      TimePeriodEnum.SIXTY_DAYS,
      TimePeriodEnum.NINETY_DAYS,
      TimePeriodEnum.ALL_TIME,
      TimePeriodEnum.CUSTOM
    ];

    return options.map(option => ({
      label: intl.formatMessage({ id: `forms.timePeriod.periodOptions.${option}` }),
      value: option
    }));
  }, [intl]);

  return (
    <>
      <IonCol>
        <Select<PartialFormData>
          control={form.control}
          error={form.formState.errors.timePeriod}
          label={intl.formatMessage({ id: 'forms.timePeriod.timePeriodLabel' })}
          name="timePeriod"
          options={timePeriodOptions}
        />
      </IonCol>
      <IonCol className={timePeriod === TimePeriodEnum.CUSTOM ? '' : 'ion-hide'}>
        <div className={styles.item}>
          <DateInput<PartialFormData>
            control={form.control}
            error={form.formState.errors.startDate}
            label={intl.formatMessage({ id: 'forms.timePeriod.startTimeLabel' })}
            name="startDate"
          />
          <div className={styles.clear}>
            <ActionIconButton
              ariaLabelKey="accessibility.ariaLabels.delete"
              icon="times"
              onClick={() => form.setValue('startDate', '')}
            />
          </div>
        </div>
      </IonCol>
      <IonCol className={timePeriod === TimePeriodEnum.CUSTOM ? '' : 'ion-hide'}>
        <div className={styles.item}>
          <DateInput<PartialFormData>
            control={form.control}
            error={form.formState.errors.endDate}
            label={intl.formatMessage({ id: 'forms.timePeriod.endTimeLabel' })}
            name="endDate"
          />
          <div className={styles.clear}>
            <ActionIconButton
              ariaLabelKey="accessibility.ariaLabels.delete"
              icon="times"
              onClick={() => form.setValue('endDate', '')}
            />
          </div>
        </div>
      </IonCol>
    </>
  );
};

export default TimePeriodField;
